import { useState, useContext } from "react";
import {
  useDataProvider,
  usePaginationState,
  useNotify,
  useAuthProvider,
} from "react-admin";
import { buildFilter } from "../utils";
import { AppContext } from "../context/AppProvider";

export function useGetData() {
  const {
    permissions,
    userBusiness,
    userBranch,
    userBusinessSelected,
    userBranchSelected,
  } = useContext(AppContext);
  const { getList, getOneList } = useDataProvider();
  const { getUsers } = useAuthProvider();
  const [listData, setListData] = useState({});
  const [listDataUsers, setListDataUsers] = useState({});
  const [modalErrorReq, setModalErrorReq] = useState(false);
  const [listDataById, setListDataById] = useState({});
  const notify = useNotify();
  const { page, setPage, perPage, setPerPage } = usePaginationState({
    page: 1,
    perPage: 15,
  });

  const getData = (
    resource,
    filterField = "",
    filter = "",
    groupByField = "",
    quickFilter = ""
  ) => {
    if (filter.includes("&branch_id") && userBranchSelected) {
      filter = filter.replace("&branch_id=", "");
    }
    let branch = userBranch;
    if (permissions === "Admin" && !userBranchSelected) {
      branch = "0";
    }
    getList(resource, {
      businessId: userBusiness === "0" ? "" : userBusiness,
      branchId: userBranchSelected === "0" || branch === "0" ? "" : branch,
      pagination: {
        page: page,
        perPage: perPage,
      },
      filter: buildFilter(filterField, filter, groupByField, quickFilter),
    })
      .then((response) => {
        setListData(response);
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          (err.response.data.result === "The terminal does not exist" || err.response.data.result === "The terminal_id does not exist")
        ) {
          notify("ra.notification.terminal_not_found_error", "error");
        } else {
          notify("ra.notification.unexpected_error", "error");
        }
        setListData({ data: [] });
      });
  };

  const getUsersList = (cognitoFilters, otherFilters) => {
    getUsers(cognitoFilters)
      .then((users) => {
        let newUsers = users;
        if (otherFilters.length !== 0) {
          newUsers = getUsersByFilters(
            newUsers,
            Object.keys(otherFilters[0])[0],
            Object.values(otherFilters[0])[0]
          );
          if (otherFilters.length > 1) {
            newUsers = getUsersByFilters(
              newUsers,
              Object.keys(otherFilters[1])[0],
              Object.values(otherFilters[1])[0]
            );
          }
        }
        if (cognitoFilters.length > 1) {
          newUsers = getUsersByFilters(
            newUsers,
            Object.keys(cognitoFilters[1])[0],
            Object.values(cognitoFilters[1])[0]
          );
        }

        if (userBusiness !== '0') {
          newUsers = getUsersByFilters(newUsers, "business", userBusiness);
        }

        if (userBranchSelected) {
          newUsers = getUsersByFilters(newUsers, "branch_id", userBranch);
        }
        newUsers.total = newUsers.data.length
        setListDataUsers(newUsers);
      })
      .catch((err) => {
        notify("ra.notification.unexpected_error", "error");
      });
  };

  const getUsersByFilters = (users, field, filter) => {
    if (
      field === "business" ||
      field === "business_id" ||
      field === "branch_id"
    ) {
      if (field === "business_id") {
        field = "business";
      }
      if(window.localStorage.getItem("email")){
        return {
          data: users.data.filter((user) => {
            
            const fieldValueEmail = user.Attributes.find((elem) => elem.Name.includes("email"))?.Value;
            const fieldValue = parseInt(user.Attributes.find((elem) => elem.Name.includes(field))?.Value);
            const tellerValue = user.Attributes.find((elem) => elem.Name.includes("role"))?.Value;
        
            return (fieldValue === parseInt(filter) && fieldValueEmail === window.localStorage.getItem("email")) || 
            (fieldValue === parseInt(filter) && tellerValue === 'Teller'); // Asegúrate de que el valor de "teller" exista
          }),
        };
      }else{
        return {
          data: users.data.filter(
            (user) =>
              parseInt(
                user.Attributes.find((elem) => elem.Name.includes(field)).Value
              ) === parseInt(filter)
          ),
        };
      }
      
    } else if (field === "email" || field === "name") {
      return {
        data: users.data.filter((user) =>
          user.Attributes.find((elem) =>
            elem.Name.includes(field)
          ).Value.includes(filter)
        ),
      };
    }
  };

  const getAllData = (resource, setData, businessId) => {
    getList(resource, {
      businessId:
        resource === "business"
          ? ""
          : resource === "category" && userBusiness !== "0"
            ? userBusiness
            : resource === "category" && businessId
              ? businessId
              : permissions === "Root"
                ? ""
                : userBusiness,
      pagination: {
        page: 1,
        perPage: "",
      },
      filter: buildFilter("", "", "", ""),
    })
      .then((response) => {
        setData(response);
      })
      .catch((err) => {
        notify("ra.notification.unexpected_error", "error");
        if (modalErrorReq === false) {
          setModalErrorReq(true);
        }
      });
  };

  const getAllDataBranch = async (resource, setData, businessId) => {
    try {
      const response = await getList(resource, {
        businessId:
          resource === "business"
            ? ""
            : resource === "category" && userBusiness !== "0"
              ? userBusiness
              : resource === "category" && businessId
                ? businessId
                : permissions === "Root"
                  ? ""
                  : userBusiness,
        pagination: {
          page: 1,
          perPage: "",
        },
        filter: buildFilter("", "", "", ""),
      });
      setData(response);
      return response;
    } catch (err) {
      notify("ra.notification.unexpected_error", "error");
      if (modalErrorReq === false) {
        setModalErrorReq(true);
      }
    }
  };

  const getListById = (resource, resourceId) => {
    getOneList(resource, { id: resourceId })
      .then((response) => {
        let res = response;
        setListDataById(res);
      })
      .catch((err) => {
        notify("ra.notification.unexpected_error", "error");
      });
  };

  return {
    getData,
    setPage,
    page,
    perPage,
    setPerPage,
    listData,
    setListData,
    getAllData,
    getUsersList,
    getListById,
    listDataById,
    setListDataById,
    getUsersByFilters,
    modalErrorReq,
    setModalErrorReq,
    listDataUsers,
    setListDataUsers,
    getAllDataBranch
  };
}
